<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.keyword"
              @keyup.enter="query"
              type="search"
              :placeholder="$l('table_search_placeholder')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_custStatus') || '客户状态'">
              <el-checkbox-group v-model="form.listCustStatus">
                <el-checkbox label="W" name="type">
                  {{ $l('form_label_custStatus_W') || '待审批' }}
                </el-checkbox>
                <el-checkbox label="P" name="type">
                  {{ $l('form_label_custStatus_P') || '审批中' }}
                </el-checkbox>
                <el-checkbox label="B" name="type">
                  {{ $l('form_label_custStatus_B') || '驳回' }}
                </el-checkbox>
                <el-checkbox label="Y" name="type">
                  {{ $l('form_label_custStatus_Y') || '有效' }}
                </el-checkbox>
                <el-checkbox label="N" name="type">
                  {{ $l('form_label_custStatus_N') || '无效' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custNo') || '客户编号'">
              <el-input
                v-model.trim="form.custNo"
                :placeholder="$l('form_placeholder_custNo') || '请输入客户编号'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custName') || '客户名称'">
              <el-input
                v-model.trim="form.custName"
                :placeholder="
                  $l('form_placeholder_custName') || '请输入客户公司名称'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_region') || '所在国家'">
              <dict-select
                v-model="form.listRegionCode"
                url="/master/common/dict/biz"
                :body="{ dictType: 'region' }"
                :placeholder="$l('form_placeholder_region') || '请选择所在国家'"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_businessLicense') || '公司税号'"
            >
              <el-input
                v-model.trim="form.businessLicense"
                :placeholder="
                  $l('form_placeholder_businessLicense') || '请输入客户公司税号'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_customerBizType') || '客户类型'"
            >
              <dict-select
                v-model="form.customerBizType"
                :placeholder="
                  $l('form_placeholder_customerBizType') || '请选择客户类型'
                "
                url="/digitalCenter/common/dict/system"
                :body="{ dictType: 'customerBizType' }"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_customerType') || '客户性质'">
              <dict-select
                v-model="form.customerType"
                :placeholder="
                  $l('form_placeholder_customerType') || '请选择客户性质'
                "
                url="/digitalCenter/common/dict/biz"
                :body="{ dictType: 'customerType' }"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_riskLevel') || '风险等级'">
              <dict-select
                v-model="form.riskLevel"
                :placeholder="
                  $l('form_placeholder_riskLevel') || '请选择风险等级'
                "
                url="/digitalCenter/common/dict/system"
                :body="{ dictType: 'riskLevel' }"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_createBy') || '创建人'">
              <dict-select
                v-model="form.listCreateBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_createBy') || '请选择创建人'"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_modifyBy') || '修改人'">
              <dict-select
                v-model="form.listModifyBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_modifyBy') || '请选择修改人'"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_createDate') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    :placeholder="
                      $l('form_placeholder_createDate') || '请选择创建时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    :placeholder="
                      $l('form_placeholder_createDate') || '请选择创建时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    :placeholder="
                      $l('form_placeholder_modifyDate') || '请选择修改时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    :placeholder="
                      $l('form_placeholder_modifyDate') || '请选择修改时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = { keyword: '', listCustStatus: ['W', 'Y', 'P', 'B'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
